/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { renownOidcClientClientActions } from "./gen/creators.js";

/** Actions for the RenownOidcClient document model */

export const actions = { ...baseActions, ...renownOidcClientClientActions };
